export const buildReportPayload = (flatPayload) => {
  const { PageNumber, PageSize, OrderColumn, OrderBy, ...filters } =
    flatPayload;
  return {
    ...filters,
    paging: {
      pageNumber: PageNumber || 1,
      pageSize: PageSize || 50,
      orderColumn: OrderColumn || "CreatedDate",
      orderBy:
        OrderBy === "ascend" ? "asc" : OrderBy === "descend" ? "desc" : "desc",
    },
  };
};
